module.exports = __webpack_public_path__ + "asset/image/minusIcon-496f.svg";